import { render, staticRenderFns } from "./ReportManager.vue?vue&type=template&id=1455979a&scoped=true"
import script from "./ReportManager.vue?vue&type=script&lang=js"
export * from "./ReportManager.vue?vue&type=script&lang=js"
import style0 from "./ReportManager.vue?vue&type=style&index=0&id=1455979a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455979a",
  null
  
)

export default component.exports